import React from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  RenderingProviderDTO,
} from 'dtos/renderingProviderDTO';
import {
  DeleteConfigCell,
  NPICell,
} from 'views/EMR/Settings/BillingConfigurations/columns';
import UsesCell from 'views/EMR/Settings/BillingConfigurations/UsesCell';
import pick from 'lodash/pick';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

const statKeys = ['appointments', 'claims', 'availibilitySlots', 'billingProviderRules'];

const renderingProviderColumns: ColumnDef<RenderingProviderDTO>[] = [{
  id: 'name',
  accessorKey: 'name',
  columnTitle: 'Name',
  meta: { autoSized: true },
  cell: ({ row: { original: { formattedNames } } }) => (
    <div>
      {getDisplayName(formattedNames)}
    </div>
  ),
}, {
  id: 'npi',
  accessorKey: 'npi',
  columnTitle: 'NPI',
  size: 350,
  cell: ({ row: { original: { npi } } }) => (<NPICell npi={npi} />),
}, {
  id: 'properties',
  accessorKey: 'isInternal',
  columnTitle: 'Properties',
  size: 150,
  cell: ({ row: { original: { isPrincipal } } }) => (
    <div className="flex gap-1">
      {isPrincipal ? (
        <span className="!truncate">
          Principal
        </span>
      ) : <span>—</span>}
    </div>
  ),
}, {
  id: 'stats',
  accessorKey: 'stats',
  columnTitle: 'Uses',
  size: 96,
  minSize: 48,
  cell: ({ row: { original: { stats, renderingProviderId } } }) => (
    <UsesCell
      {...pick(stats, statKeys) as Record<string, number>}
      id={renderingProviderId ?? 0}
    />
  ),
}, {
  id: 'actions',
  accessorKey: 'actions',
  columnTitle: '',
  size: 48,
  cell: ({ row: { original: { renderingProviderId, stats } } }) => (
    <DeleteConfigCell
      type="renderingProvider"
      configTitle="Rendering Provider"
      payload={{ renderingProviderId }}
      canDelete={stats?.canDelete ?? false}
      tooltip={!stats?.canDelete ? 'Deleting a rendering provider is not supported at this time.' : undefined}
    />
  ),
}];

export default renderingProviderColumns;
